export default __webpack_public_path__ + "static/media/close.51fe9d33.svg";